
    import { Component } from 'vue-property-decorator';
    import ListBase from '@/lib/listbase';
    import PageRequest from '@/store/entities/page-request';
    import ListView from '@/components/helper/list-view.vue';
    import FormBase from '@/components/helper/form-base.vue';
    import quizForm from './quiz-form.vue';
    import Stats from './stats.vue';

    class PagequizRequest extends PageRequest {
        year: any = parseInt(new Date().toISOString().substr(0, 4));
        month: any = parseInt(new Date().toISOString().substr(5, 2));
        dealer: number = null;
        manufacturer: number = null;
        customer: string = null;
    }

    @Component({
        components: { ListView, quizForm, FormBase, Stats },
        watch: {
            dealer: function (val) {
                let vm = (this as any);
                vm.pagerequest.dealer = val;
                if (vm.current_view == 'list')
                    vm.getpage();
                else if (vm.$refs.stat != undefined){
                    vm.$refs.stat.loadData();
                }
            }
        }
    })
    export default class quizs extends ListBase {
        entity: string = 'quiz';
        pagerequest: PagequizRequest = new PagequizRequest();
        filterForm: boolean = true;
        views: Array<any> = [{ code: "stats", title: "Ver Estadisticas", icon: "bar_chart" }];
        current_view: string = 'list';

        filterItems = [
            this.gItem({ type: 'select', prop: 'year', label: 'Anio', options: 'years', hideDetails: true, onchange: this.changeYear, size: 2 }),
            this.gItem({ type: 'select', prop: 'month', label: 'Mes', options: 'months', hideDetails: true, onchange: this.changeMonth, size: 2 }),
            this.gItem({ type: 'text', prop: 'customer', label: 'Buscar Cliente por Nombre', hideDetails: true, onchange: this.changeMonth, size: 4 }),
            this.gItem({ type: 'spacer', prop: 'spacer', size: 4 }),
        ]

        columns = [
            this.gCol('dealer.name', 'Concesionario', 'text'),
            this.gCol('customer', 'Empresa', 'text'),
            this.gCol('cellphone', 'Telefono', 'text'),
            this.gCol('email', 'Email', 'text'),
            this.defaultActions('view')
        ]

        get dealer() {
            return this.$store.state.app.dealer;
        }
        get manufacturer() {
            return this.$store.state.app.manufacturer;
        }
        get checking() {
            return this.$store.state.dashboard.loading;
        }
        get widgets() {
            let quizs = this.$store.state.dashboard.quizzes;
            return [
                { value: (quizs[0] != undefined ? quizs[0] : '0'), name: 'Encuestas', icon: 'point_of_sale', desc: 'Nro Total de Encuestas', onclick: null },
                { value: (quizs[1] != undefined ? quizs[1] : '0'), name: 'Enviadas', icon: 'home_repair_service', desc: 'Encuestas Enviadas', onclick: null },
                { value: (quizs[2] != undefined ? quizs[2] : '0'), name: 'Respondidas', icon: 'pending', desc: 'Encuestas Respondidas', onclick: null },
                { value: (quizs[3] != undefined ? quizs[3] : '0'), name: 'Cobertura', icon: 'schedule', desc: 'Porcentaje de Respuesta', onclick: null },
            ];
        }


        view() {
            this.modalShow = !this.modalShow;
        }

        changeView(item) {
            this.current_view = item;
            this.setItem(this.filterItems, 'month', 'visible', (item == 'list'));
            this.setItem(this.filterItems, 'customer', 'visible', (item == 'list'));
            this.setItem(this.filterItems, 'spacer', 'size', (item == 'list' ? 4 : 10));
        }

        async changeYear() {
            if (this.current_view == 'list') {
                await this.getpage();
                await this.loadData();
            }
            else if (this.$refs.stat != undefined) {
                (this.$refs.stat as any).loadData();
            }
        }

        async changeMonth() {
            await this.getpage();
            await this.loadData();
        }

        async getpage() {
            let list: any = this.$refs.listView
            if (list != undefined) {
                this.pagerequest.dealer = this.dealer;
                this.pagerequest.manufacturer = this.manufacturer;
                await list.getpage();
            }
        }
        async loadData() {
            await this.$store.dispatch({
                type: 'dashboard/getWidgetQuizzes',
                data: {
                    year: this.pagerequest.year,
                    month: this.pagerequest.month
                }
            });
        }

        async mounted() {
            await this.loadData();
        }

        created() {
            this.pagerequest.dealer = this.dealer;
            this.pagerequest.manufacturer = this.manufacturer;
        }
    }
